import { Button } from "@/components/ui/button";
import { motion } from "framer-motion";
import { Clock, Shield, ArrowRight } from "lucide-react";

const AuditStrip = () => (
  <section
    id="audit-cta"
    aria-label="Free AI audit call to action"
    className="py-14 md:py-20 bg-primary text-primary-foreground relative overflow-hidden"
  >
    {/* Subtle radial glow */}
    <div
      aria-hidden
      className="pointer-events-none absolute inset-0"
      style={{
        background:
          "radial-gradient(ellipse 70% 60% at 50% 50%, hsl(var(--accent) / 0.18), transparent 70%)",
      }}
    />

    <div className="container mx-auto relative">
      <motion.div
        initial={{ opacity: 0, y: 20 }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true, margin: "-60px" }}
        transition={{ duration: 0.5, ease: "easeOut" }}
        className="flex flex-col items-center text-center gap-6 max-w-2xl mx-auto"
      >
        <h2 className="text-3xl md:text-4xl font-bold font-display leading-tight">
          Find out exactly where you're&nbsp;losing time — free, no&nbsp;pitch.
        </h2>

        <p className="text-lg text-primary-foreground/80 max-w-xl">
          In 15 minutes I'll map your biggest workflow bottleneck and show you
          what AI can automate first. You leave with a clear plan, whether we
          work together or not.
        </p>

        <Button
          variant="secondary"
          size="lg"
          asChild
          className="bg-accent hover:bg-accent/90 text-accent-foreground font-semibold px-8 text-base group"
        >
          <a href="#contact">
            Book Your Free Audit
            <ArrowRight
              className="ml-2 h-4 w-4 transition-transform group-hover:translate-x-1"
              aria-hidden
            />
          </a>
        </Button>

        <div className="flex flex-wrap justify-center gap-6 text-sm text-primary-foreground/70 mt-2">
          <span className="flex items-center gap-1.5">
            <Clock className="h-4 w-4 text-accent" aria-hidden />
            15 minutes, no prep needed
          </span>
          <span className="flex items-center gap-1.5">
            <Shield className="h-4 w-4 text-accent" aria-hidden />
            No sales pitch — just value
          </span>
        </div>
      </motion.div>
    </div>
  </section>
);

export default AuditStrip;
